import facebookIcon from "@assets/social/facebook.svg";
import newPostIcon from "@assets/social/newPost.svg";
import telegramIcon from "@assets/social/telegram.svg";
import whatsappIcon from "@assets/social/whatsapp.svg";
import LinkIcon from "@elements/Icon/LinkIcon";
import { removeLeadingSlash } from "@helper/removeTrailingLeadingSlash";
import { getWindowOrigin } from "@helper/utils";

export type SocialVariant =
  | "facebook"
  | "telegram"
  | "whatsapp"
  | "plainWhatsapp"
  | "newsPost";

export type ShareSocialProps = {
  variant: SocialVariant;
  pageTitle?: string;
  pagePath: string;
  width?: string;
  dateCreated?: string;
  isAbsolutePagePath?: boolean;
};

export default function ShareSocial({
  variant,
  pageTitle,
  pagePath,
  dateCreated,
  width = "35px",
  isAbsolutePagePath = false,
}: ShareSocialProps) {
  const origin = getWindowOrigin();
  const shareTitle = pageTitle && encodeURIComponent(pageTitle);
  const sharePath = isAbsolutePagePath
    ? encodeURIComponent(pagePath)
    : encodeURIComponent(`${origin}/${removeLeadingSlash(pagePath)}`);
  const teleDestination = shareTitle
    ? `${sharePath}&text=${shareTitle}`
    : sharePath;
  const whatsappDestination = shareTitle
    ? `${shareTitle}%0A${sharePath}`
    : sharePath;
  const newsPostDestination = shareTitle;
  switch (variant) {
    case "facebook":
      return (
        <LinkIcon
          destination={`https://www.facebook.com/sharer/sharer.php?u=${sharePath}`}
          src={facebookIcon}
          alt="Share on Facebook"
          width={width}
        />
      );
    case "telegram":
      return (
        <LinkIcon
          destination={`https://t.me/share/url?url=${teleDestination}`}
          src={telegramIcon}
          alt="Share on Telegram"
          width={width}
        />
      );
    case "whatsapp":
      return (
        <div className="flex items-center bg-white-200 rounded-whatsapp w-[98px] h-[35px] gap-1">
          <LinkIcon
            destination={`https://wa.me/?text=${whatsappDestination}`}
            src={whatsappIcon}
            alt="Share on WhatsApp"
            width="50px"
          />
          <span className="text-xxxs text-grey-800">Kongsi di Whatsapp</span>
        </div>
      );
    case "plainWhatsapp":
      return (
        <LinkIcon
          destination={`https://wa.me/?text=${whatsappDestination}`}
          src={whatsappIcon}
          alt="Share on WhatsApp"
          width={width}
        />
      );
    case "newsPost":
      return (
        <div className="flex items-center bg-white-200 rounded-whatsapp w-[160px] h-[35px] gap-1">
          <LinkIcon
            destination={`https://newspost.newslink.sg/?publication=BH&date=${dateCreated}&title=${newsPostDestination}`}
            src={newPostIcon}
            alt="Purchase this article"
            width="35px"
          />
          <span className="text-xxxs text-grey-800 leading-[101%]">
            Dapatkan artikel ini
            <br />
            untuk diterbitkan semula
          </span>
        </div>
      );
    default:
      return null;
  }
}
